const BFM_BlockContainer = (params) => {
    const { type, icon } = params;

    const getBodyContent = (type) => {
        switch (type) {
            case "if":
                return `if`;
            case "ai":
                return "ai";
            case "execute":
                return "execute";
            case "setVariable":
                return "setVariable";
            case "db":
                return "db";
            case "notes":
                return "notes";
            case "macro":
                return "macro";
            default:
                return "---";
        }
    }

    return (
        <div className="card mb-3" style={{ width: '200px', height: '300px' }}>
            <div className="card-header d-flex align-items-center gap-2" style={{ 
                backgroundColor: '#C1CDCD',
                padding: '0.5rem',
                minHeight: '60px'
            }}>
                <div className="p-1 rounded d-flex align-items-center justify-content-center">
                    <span style={{ width: '70px', height: '70px' }}>{icon}</span>
                </div>
                <span className="fw-bold fs-5" style={{ color: '#000' }}>{type.toUpperCase()}</span>
            </div>
            <div className="card-body">
                <div style={{ height: '100px' }}></div>
                <p className="card-text text-center">
                    {getBodyContent(type)}
                </p>
            </div>
        </div>
    );
}

export default BFM_BlockContainer;


